import { registerFirstTime, gotoGame } from "../../js/api/liveCasino.js";

let LiveCasino = {
    render: async () => {
        let view =  /*html*/`
            <iframe style="width: 100%; height: 83vh;" src="data:text/html,<h1></h1>" id="gameIframe" frameborder="0" noresize="noresize" allow="geolocation 'self'; autoplay 'self'"></iframe>
        `
        return view;
    },
    after_render: async () => {
        // document.querySelector('meta[name="viewport"]').setAttribute("content", 'width=initial');
        let key1;
        let key2;
        let sessionid;
        let userId = localStorage.getItem('user_id');


        let starGameId = localStorage.getItem("starGameId");
        const response = await registerFirstTime();


        if( response && response.token !== null ){
            localStorage.setItem('access_token', response.token.jwt);
        }
        if (starGameId == null || starGameId == undefined || starGameId == ''){
            // const response = await checkLiveCasino();
            // console.log(response, 'response-eeee');
        } else {
            let checkStatus = await gotoGame();
            const gameId = 11;
            key1 = checkStatus.key1;
            key2 = checkStatus.key2;
            sessionid = checkStatus.sessionid;
            if(checkStatus.success == true){
                $('#gameIframe').attr('src', ` https://apiserver.solutions/showgame?gameid=${gameId}&sid=${sessionid}&key1=${key1}&key2=${key2}&username=${userId}&uwidth=auto&uheight=auto`);       
                // $('#gameIframe').attr('src', `https://apiserver.solutions/showgame?gameid=1358&sid=${sessionid}&key1=${key1}&key2=${key2}&username=${userId}&uwidth=auto&uheight=auto`);       
            }
        }


    },
    on_unload: async (socket) => {
        document.querySelector('meta[name="viewport"]').setAttribute("content", 'width=device-width, initial-scale=1');
    },
}

export default LiveCasino;
